import { render, staticRenderFns } from "./GameRevenue.vue?vue&type=template&id=93d3badc&"
import script from "./GameRevenue.vue?vue&type=script&lang=js&"
export * from "./GameRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports